import styled from 'styled-components';

export const SmallCaps = styled.span`
  font-variant: small-caps;
  font-weight: var(--t-bold);
  font-size: 0.6em;
`;
